import { v4 } from 'uuid'
import { sm2 } from 'sm-crypto'
import { util } from 'node-forge'

import { useState } from 'react'
import { useRequest, clearCache } from 'ahooks'

import { Input } from 'antd'
import { LoginForm, ProFormText, ProFormItem } from '@ant-design/pro-components'

export default function({ store, navigator }) {
  const [ uuid, dispatch ] = useState(v4())

  const img = useRequest(() => (
    fetch(`${store.config.env.api}/auth/code?uuid=${uuid}`)
      .then(response => response.arrayBuffer())
      .then(response => util.binary.hex.encode(response))
      .then(response => util.binary.hex.decode(response))
      .then(response => util.binary.base64.encode(response))
  ), {
    refreshDeps: [ uuid ]
  })

  const handleSubmit = useRequest(async data => {
    const result = await store.externals.api.post(`/auth/login?uuid=${data.uuid}`, data)

    store.identity.dispatch('user', result.emp)
    store.identity.dispatch('uid', result.emp.id)
    store.identity.dispatch('token', result.token)
  }, {
    manual: true,
  })

  return <div className='flex flex-col h-screen items-center justify-center bg-gray-800'>
    <div className='flex flex-col justify-center space-y-4 bg-white p-8 pt-4'>
      <LoginForm
        title={store.config.env.title}
        subTitle={store.config.env.subtitle}
        contentStyle={{ width: 360 }}
        onFinish={data => handleSubmit.runAsync({ ...data, uuid, password: '04' + sm2.doEncrypt(data.password, `046f6c922880f70e5e1767112b36ea38cfe5eabe65d4fa4f369b66ee53ed98ca610fb55bf8b294ec69c6cb20a7580c860c3e95348024631d76e403611b6fae9bb7`, 0) }).then(() => clearCache()).then(() => navigator.to('/addressing'))}
      >
        <ProFormText
          width='xl'
          name='name'
          placeholder='用户名'
          rules={[{ required: true, message: '请输入用户名!' }]}
          fieldProps={{ size: 'large', prefix: <span className='fa fa-user text-gray-600 px-2' /> }}
        />

        <ProFormText.Password
          width='xl'
          name='password'
          placeholder='登录密码'
          rules={[{ required: true, message: '请输入登录密码!' }]}
          fieldProps={{ size: 'large', prefix: <span className='fa fa-lock text-gray-600 px-2' /> }}
        />

        <ProFormItem
          name='code'
          rules={[{ required: true, message: '请输入验证码!' }]}
        >
          {React.createElement(({ value, onChange }) => {
            return <div className='flex items-center justify-center space-x-2'>
              <Input
                value={value}
                size='large'
                placeholder='请输入验证码'
                onChange={e => onChange(e.target.value)}
                prefix={<span className='fa fa-certificate text-gray-600 px-2' />}
              />

              <img
                alt='验证码'
                title='点击刷新'
                className='h-10 cursor-pointer'
                onClick={() => dispatch(v4())}
                src={`data:image/jpg;base64,${img.data ? img.data : ''}`}
              />
            </div>
          })}
        </ProFormItem>
      </LoginForm>
    </div>
  </div>
}
